import React from "react";
import {useApolloClient} from "@apollo/client";
import {useSocketData} from "@unibuddy/sockets";
import meQuery from "shared/Auth/queries/meQuery";
import useAuth from "shared/Auth/hooks/useAuth";
import {setMe} from "shared/Auth/actions/authActions";
import {delinkApplicantEvent} from "./Sockets";
import {useUniversity} from "../UniversityProvider/UniversityProvider";
import {getReduxDispatch} from "../../../App";

type DelinkedMessageData = {
    delinked: boolean;
    universitySlug: string;
};

/**
 * Component that listens to socket delinked messages and updates auth state if needed.
 */
export const SocketDelinkListener = () => {
    const {authState} = useAuth();
    const {slug: universitySlug} = useUniversity();
    const client = useApolloClient();
    const dispatch = getReduxDispatch();

    const delinkedMessageData = useSocketData<DelinkedMessageData>({
        event: delinkApplicantEvent,
        channelId: authState?.me?.anyUser?.id,
    });

    React.useEffect(() => {
        if (
            delinkedMessageData &&
            delinkedMessageData?.delinked &&
            delinkedMessageData?.universitySlug === universitySlug
        ) {
            const fetchAndUpdate = async () => {
                const result = await client.query({
                    query: meQuery,
                    fetchPolicy: "network-only",
                });
                dispatch(setMe(result.data.me));
            };

            fetchAndUpdate();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [delinkedMessageData]);

    return null;
};
